import { HttpRequest } from '@lib/http/HttpRequest';

import type { TPayloadValue } from '@lib/types/THttpRequest';
import type { THttpResponse, TReturnable, THttpResponseOptions } from '@lib/types/THttpResponse';

/**
 * @private Do not use this class directly
 */
export class GetRequest extends HttpRequest {
  constructor(
    endpoint: Maybe<string>,
    tokenTask: () => Promise<Maybe<string>>,
    query?: Maybe<Record<string, TPayloadValue>>,
    headers?: Maybe<Record<string, string>>,
    tokenRefresher?: Maybe<() => Promise<Maybe<string>>>,
  ) {
    super(endpoint ?? undefined);

    this.setMethod('GET');
    this.setTokenFetcher(tokenTask);

    if (tokenRefresher != null) {
      this.setTokenRefresher(tokenRefresher);
    }

    if (query != null) {
      this.setQuery(query);
    }

    if (headers != null) {
      this.setHeaders(headers);
    }
  }

  public override async send<T extends TReturnable>(
    responseOptions?: Maybe<THttpResponseOptions>,
    abortController?: Maybe<AbortController>,
  ): Promise<THttpResponse<T>> {
    if (abortController != null) {
      this.setAbortController(abortController);
    }

    return await super.send(responseOptions);
  }
}
